/** Hands a prompt to the active composer, such as from an example in the feed. */
export const COMPOSER_PROMPT_EVENT = "afterform:composer-prompt";

export interface ComposerPromptRequest {
  media: "image" | "video" | "audio" | "3d";
  prompt: string;
}

// A prompt written on another screen waits here until its composer becomes active.
let pending: (ComposerPromptRequest & { at: number }) | undefined;
const PENDING_TTL_MS = 30_000;

export function requestComposerPrompt(request: ComposerPromptRequest, { persist = false }: { persist?: boolean } = {}): void {
  pending = persist ? { ...request, at: Date.now() } : undefined;
  window.dispatchEvent(new CustomEvent<ComposerPromptRequest>(COMPOSER_PROMPT_EVENT, { detail: request }));
}

/** Returns and clears a prompt handed over from another screen for this medium. */
export function takePendingComposerPrompt(media: ComposerPromptRequest["media"]): string | undefined {
  if (!pending || pending.media !== media) return undefined;
  const { prompt, at } = pending;
  pending = undefined;
  return Date.now() - at <= PENDING_TTL_MS ? prompt : undefined;
}
